import React, { useState } from "react"
import { useShallow } from "zustand/react/shallow"
import useAuthoringCommentsStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringCommentsStore"
import { schemaOptionsFilter } from "../../utils"

// components
import { Select } from "components-design-system"
import Modal from "components/Modal/Modal"
import { PrimeButton } from "components-design-system"
import RJTableCommentContainer from "../../components/RJTableCommentContainer/RJTableCommentContainer"

import "./CountryRow.scss"

const CountryRow = ({ country, schema, onChange, onDeleteCountry, i, formView, readOnly }) => {
  const [showMenu, setShowMenu] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openCommentsForm, setOpenCommentsForm] = useState(false)

  const { commentsMap } = useAuthoringCommentsStore(
    useShallow((state) => ({
      commentsMap: state.commentsMap,
    }))
  )

  const jpath = "results-trial-countries-" + country?.country_name

  return (
    <div
      className="country-row-container"
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
    >
      <Select
        options={schemaOptionsFilter(schema.options, formView).filter((item) => item.value !== "Korea, South")}
        readOnly={readOnly}
        value={country.country_name}
        onChange={(e) => onChange(e, i, "country_name")}
        style={{ width: "100%" }}
      />
      {showMenu && !readOnly && (
        <i
          className="rjs-delete fal fa-trash-alt animate__animated animate__fadeIn animate__faster"
          onClick={() => setOpenModal(true)}
        />
      )}
      {jpath && (
        <RJTableCommentContainer
          label={`Trial Country`}
          jpath={jpath}
          openCommentsForm={openCommentsForm}
          setOpenCommentsForm={setOpenCommentsForm}
          setShowMenu={setShowMenu}
          showMenu={showMenu || commentsMap[jpath] || openCommentsForm}
          style={{ marginBottom: 2 }}
        />
      )}

      <Modal
        title={`Are you sure you want to delete?`}
        open={openModal}
        onCancel={() => setOpenModal(false)}
        className={"pft-comment-modal"}
        footer={[]}
        type="delete"
      >
        <div className="delete-text">NOTE: This action can not be undone.</div>

        <div className="action-container">
          <PrimeButton onClick={() => setOpenModal(false)}>Cancel</PrimeButton>
          <PrimeButton
            type="primary"
            danger
            onClick={() => {
              onDeleteCountry(i)
              setOpenModal(false)
              setShowMenu(false)
            }}
          >
            Delete
          </PrimeButton>
        </div>
      </Modal>
    </div>
  )
}

export default CountryRow
